import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';
import throttle from 'lodash/throttle';

const sliders = document.querySelectorAll(
	'.block-hero-archive-featured .swiper'
);
const mobileButtons = document.querySelectorAll(
	'.block-hero-archive-featured__mobile-select-button'
);

let previousWidth = window.innerWidth;

sliders.forEach((slider) => {
	const settings = {
		loop: false,
		grabCursor: true,
		spaceBetween: 16,
		slidesPerView: 1,
		modules: [A11y, Navigation, Pagination],
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		pagination: {
			el: slider.parentElement.querySelector('.swiper-pagination'),
			clickable: true,
		},
	};

	new Swiper(slider, settings);
});

const clickMobileButton = (e) => {
	if (!e.currentTarget.nextElementSibling) {
		return;
	}

	e.preventDefault();

	if (
		e.currentTarget.classList.contains(
			'block-hero-archive-featured__mobile-select-button--open'
		)
	) {
		e.currentTarget.classList.remove(
			'block-hero-archive-featured__mobile-select-button--open'
		);
		e.currentTarget.nextElementSibling.setAttribute(
			'aria-expanded',
			'false'
		);
	} else {
		e.currentTarget.classList.add(
			'block-hero-archive-featured__mobile-select-button--open'
		);
		e.currentTarget.nextElementSibling.setAttribute(
			'aria-expanded',
			'true'
		);
	}
};

const closeMobileButtons = () => {
	if (previousWidth && previousWidth >= 768 && window.innerWidth >= 768) {
		return;
	} else if (
		previousWidth &&
		previousWidth < 768 &&
		window.innerWidth < 768
	) {
		return;
	}

	mobileButtons.forEach((mobileButton) => {
		if (
			mobileButton.classList.contains(
				'block-hero-archive-featured__mobile-select-button--open'
			)
		) {
			mobileButton.classList.remove(
				'block-hero-archive-featured__mobile-select-button--open'
			);
			mobileButton.nextElementSibling.setAttribute(
				'aria-expanded',
				'false'
			);
		}
	});

	previousWidth = window.innerWidth;
};

mobileButtons.forEach((mobileButton) => {
	mobileButton.addEventListener('click', clickMobileButton);
});

window.addEventListener('resize', throttle(closeMobileButtons, 100));
